/**
 * Popup component exports
 *
 * @since 1.0.0
 */

export { Popup } from './component';
export type { PopupPosition, PopupProps } from './types';
